<!-- MODAL ver pedido -->
<div mdbModal #verPedido="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Pedido #{{cabecera?.numero_pedido | numerico}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verPedido.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="border-bottom: 1px solid #dee2e6;">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Datos cliente
            </h5>
          </div>
        </div>

        <div class="row" *ngIf="cabecera">
          <div class="col dato">
            <Strong class="title">Nombre</Strong>
            <span class="value">{{cabecera.clienteNombre}}</span>
          </div>
          <div class="col dato">
            <Strong class="title">Dirección</Strong>
            <span class="value">{{cabecera.direccion}}</span>
          </div>
          <div class="col dato">
            <Strong class="title">Fecha</Strong>
            <span class="value">
              {{cabecera.fecha_registro | fecha}}
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col mt-1">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle" *ngIf="detallePedido">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col" class="text-center">Cod. Prod.</th>
                    <th scope="col" class="text-center">Descripción</th>
                    <th scope="col" class="text-center">Estado</th>
                    <th scope="col" class="text-center">Unidad</th>
                    <th scope="col" class="text-center">Cantidad</th>
                    <th scope="col" class="text-center">Precio Unit.</th>
                    <th scope="col" class="text-center">Desc.</th>
                    <th scope="col" class="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let detalle of detallePedido">
                    <td class="text-center">{{detalle.sku}}</td>
                    <td class="text-center">{{detalle.nombreProducto}}</td>
                    <td class="text-center">
                      <mdb-badge pill="true" success="true" *ngIf="detalle.estado_producto">Activo</mdb-badge>
                      <mdb-badge pill="true" danger="true" *ngIf="!detalle.estado_producto">Inactivo</mdb-badge>
                    </td>
                    <td class="text-center">{{detalle.nombreFormato}}</td>
                    <td class="text-center">{{detalle.cantidad | numerico}}</td>
                    <td class="text-center">{{detalle.precio_unitario | numerico}}</td>
                    <td class="text-center">{{detalle.monto_descuento | numerico}}</td>
                    <td class="text-center">{{detalle.monto_total_sin_flete | numerico}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="cabecera">
          <div class="col mt-1">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="blue lighten-5">
                <tr>
                  <th scope="col" class="text-center">SubTotal</th>
                  <th scope="col" class="text-center">IVA</th>
                  <!-- <th scope="col" class="text-center">Otros impuestos</th> -->
                  <th scope="col" class="text-center">Total</th>
                </tr>
              </thead>
              <tbody class="blue lighten-5">
                <tr>
                  <td class="text-center">$ {{total_Pedidos.monto_total | numerico}}</td>
                  <td class="text-center">$ {{total_Pedidos.monto_iva | numerico}}</td>
                  <!-- <td class="text-center">-</td> -->
                  <td class="text-center">$ {{total_Pedidos.monto_bruto | numerico}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="verPedido.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>